import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, map, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { Multimedia } from '@shared/models/multimedia';
import { Template } from '@modules/template/student/models/template';
import { ClassroomCourse } from '../../models';
import { Review } from '@shared/models/review';
import { UserProfile } from '@modules/identity/models/user';
import { ClassroomCourseStoreService } from '../../store/services/classroom-course.store.service';
import { IdentityStoreService } from '@modules/identity/store/services/identity-store.service';
import { Instructor } from '@modules/instructor/models/instructor';
import { InstructorStoreService } from '@modules/instructor/client/store/instructor.store.service';
import { AuthService } from '@core/services/auth.service';
import { TemplateStoreService } from '@modules/template/student/store/services/template-store.service';
import { format, parseISO } from 'date-fns';
import { PromptDialogService } from '@shared/modals/prompt/prompt.service';
import { MetaTagService } from '@core/services/meta-tag.service';
import { TRANSLATION_SCOPE } from '../../i18n/scope';
import { ClassroomCourseApiService } from '../../store/services/classroom-course.api.service';
import { AppStoreService } from '@core/store/app-store.service';
import { InstructorIncludeType } from "@modules/instructor/enums/instructor-include-type";


@Component({
  selector: 'app-classroom-course',
  templateUrl: './classroom-course.component.html',
  styleUrls: ['./classroom-course.component.scss']
})
export class ClassroomCourseComponent implements OnInit, OnDestroy {
  classroomCourseId: string;
  classroomCourse: ClassroomCourse;
  template$: Observable<Template>;
  instructor$: Observable<Instructor> = this.instructorStore.getInstructorProfile();
  requestBookingDate: any;
  selectedSchedule: any = null;
  selectedDate: any = null;
  availability$ = this.classroomStore.getAvailableSchedule();
  seats: number;
  pricingType = { price: '', totalPrice: '' };
  userInfo$: Observable<UserProfile>;
  translationScope = TRANSLATION_SCOPE;

  reviews: Review[] = [];
  reviewTotalCount: number = 0;

  multipleParticipant: boolean = false;
  numberOfParticipant:  number = 0;

  destroy$: Subject<any>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private classroomApi: ClassroomCourseApiService,
    private classroomStore: ClassroomCourseStoreService,
    private identityStoreService: IdentityStoreService,
    private templateStore: TemplateStoreService,
    private instructorStore: InstructorStoreService,
    private promptDialogService: PromptDialogService,
    private authService: AuthService,
    private metaTag: MetaTagService,
    private appStoreService: AppStoreService,
  ) {
    this.appStoreService.setHomePageFlag(true);
    this.destroy$ = new Subject();
    this.classroomCourseId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.classroomStore
      .getClassroomCourse(this.classroomCourseId)
      .pipe(
        takeUntil(this.destroy$),
        tap((classroom) => {
          if (classroom) {
            this.templateStore.fetchTemplate(classroom.courseTemplateId);
            this.template$ = this.templateStore.getTemplate(classroom.courseTemplateId);
          }
        })
      )
      .subscribe((classroomCourse: ClassroomCourse) => {
        if (classroomCourse) {
          this.metaTag.classroomCourseOGMetaTag(classroomCourse);
          this.classroomCourse = classroomCourse;
          this.classroomStore.fetchAvailableSchedule(classroomCourse.id);
          this.instructorStore.fetchInstructorById(
            classroomCourse.instructors[0].id,
            [ InstructorIncludeType.BASIC, InstructorIncludeType.DEFAULTMEDIA, InstructorIncludeType.REVIEW ]
          );
          this.loadReviews();
        }
      });
    this.userInfo$ = this.identityStoreService.getUserProfile();

    //this.availability$ = this.classroomStore.getAvailableSchedule();
  }

  ngOnDestroy(): void {
    this.classroomStore.removeAvailableSchedule();
    this.destroy$.next();
    this.destroy$.complete();
    this.metaTag.removeOGMetaTag();
    this.appStoreService.setHomePageFlag(false);
  }

  getDefaultMedia(course: ClassroomCourse): Multimedia {
    return course.media.find((x) => x.default);
  }

  dateRange(rangeDate: any) {
    this.requestBookingDate = null;
    this.selectedSlot = null;
  }

  selectedSlot(item: any, i: any) {
    this.requestBookingDate = null;
    this.selectedSlot = i;

    this.requestBookingDate = format(this.selectedDate, 'yyyy-MM-dd');
  }

  /* onSelectedSchedule(schedule: AvailableSchedule): void {
    if(schedule) {
      this.selectedSchedule = schedule;
      this.selectedDate = schedule.startDate;
      this.seats = schedule.bookingLeft;
    } else {
      this.selectedSchedule = null;
      this.selectedDate = null;
      this.seats = 0
      this.multipleParticipant.setValue(false)
      this.numberOfParticipant.setValue(1);
    }
  } */

  onSelectedSchedule(result: any): void {

    if(result) {
      const { schedule, multipleParticipant, numberOfParticipant} = result;
      this.selectedSchedule = schedule;
      this.selectedDate = schedule.startDate;
      this.seats = schedule.bookingLeft;

      this.multipleParticipant = multipleParticipant;
      this.numberOfParticipant = numberOfParticipant;
    } else {
      this.selectedSchedule = null;
      this.selectedDate = null;
      this.seats = 0
      this.multipleParticipant = false;
      this.numberOfParticipant = 1;
    }
  }

  onSelectedDay(date: any) {
    this.selectedSlot = null;
    this.selectedDate = date;
    this.requestBookingDate = null;
  }

  availableSeats(seats: number) {
    this.seats = seats;
  }

  /* decreaseParticipant(): void {
    const value = Number(this.numberOfParticipant.value)
    if(value > 1) this.numberOfParticipant.setValue(value-1)
  }

  increaseParticipant(): void {
    const value = Number(this.numberOfParticipant.value)
    if(value < this.seats) this.numberOfParticipant.setValue(value+1)
  } */

  requestBooking(user: any) {
    if (this.selectedDate) {
      if (user !== null) {
        if (user.email_verified === true) {
          if(this.multipleParticipant) {
            this.gotoParticipantInfoPage();
          } else {
            this.redirectToBookingRequest();
          }
        }
      } else {
        this.showAnonymousPopup();
      }
    }
  }

  private gotoParticipantInfoPage() {
    this.router.navigate([`/kurs/participants/`], {
      queryParams: {
        id: this.classroomCourse.id,
        date: format(parseISO(this.selectedDate), 'yyyy-MM-dd'),
        schedule: this.selectedSchedule.id,
        participant: this.numberOfParticipant
      },
      replaceUrl: false
    });
  }

  onClickLocation(classroom: ClassroomCourse): void {
    /* let params = {
      lon: classroom.position.lon,
      lat: classroom.position.lat,
      id: classroom.id,
    };
    this.router.navigate([`/kart`, params]); */
  }

  redirectToBookingRequest() {
    this.router.navigateByUrl(
      `/booking/${this.classroomCourse.id}/classroom/request/${this.selectedDate}?scheduleId=${this.selectedSchedule.id}`
    );
  }

  showAnonymousPopup() {
    this.promptDialogService
      .openPromptDialog(
        {
          cancelButtonTextTranslate: 'Avbryt',
          icon: 'info',
          titleTranslate: 'Innlogging kreves',
          messageTranslate: 'Vennligst logg inn for å fortsette.',
          okButtonTextTranslate: 'Ok',
        },
        { panelClass: 'dialog-component' }
      )
      .afterClosed()
      .pipe(
        map((reply) => reply),
        shareReplay(1),
        takeUntil(this.destroy$)
      )
      .subscribe((reply) => {
        if (reply) {
          this.authService.login();
        }
        this.destroy$.next();
        this.destroy$.complete();
      });
  }

  rsMember(): void {
    window.open('https://www.redningsselskapet.no/medlemskap/');
  }

  loadReviews(): void {
    this.classroomApi
      .getClassroomCourseReviews(this.classroomCourse.id, 0, 3)
      .pipe(
        shareReplay(1),
        filter((reviewList) => Boolean(reviewList?.items?.length && reviewList?.items.length > 0)),
        takeUntil(this.destroy$),
        map((list) => {
          this.reviewTotalCount = list.total;
          return list.items;
        })
      )
      .subscribe((response) => {
        this.reviews = this.reviews.concat(response);
      });
  }
}
